
<template>
  <div class="wrapper">
    <img class="hub-img" src="@/assets/homekit-hubs.jpg" alt="HomeKit hubs" />
    <div class="content">
      <div class="left-text">
        <h3>{{ $t("pages.hub.hubTitle") }}</h3>
        <p>
          {{ $t("pages.hub.hubDescription") }}
        </p>
      </div>
      <div class="value-props">
        <div class="value-prop" v-for="(item, i) in valueProps" :key="i">
          <img
            :alt="item.title"
            :src="require(`@/assets/icons/${item.icon}.svg`)"
          />
          <div>
            <h3>{{ item.title }}</h3>
            <p>{{ item.text }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Hub",
  components: {},
  data() {
    return {
      valueProps: [
        {
          title: this.$t("pages.hub.localTitle"),
          icon: "no-cloud",
          text: this.$t("pages.hub.localText")
        },
        {
          title: this.$t("pages.hub.reliableTitle"),
          icon: "reliability",
          text: this.$t("pages.hub.reliableText")
        },
        {
          title: this.$t("pages.hub.privateTitle"),
          icon: "hidden",
          text: this.$t("pages.hub.privateText")
        },
        {
          title: this.$t("pages.hub.remoteTitle"),
          icon: "hub",
          text: this.$t("pages.hub.remoteText")
        }
      ]
    };
  }
};
</script>

<style scoped lang="scss">
@import "../common/_variables.scss";

.wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.hub-img {
  width: 100%;
  max-width: 700px;
  margin: 30px auto 40px auto;
}
.content {
  display: flex;
  .left-text {
    flex-basis: 0;
    flex-grow: 1;
  }
  h3 {
    margin-top: 0;
  }
  .value-props {
    flex-basis: 0;
    flex-grow: 2;
    display: flex;
    flex-wrap: wrap;
    margin-left: 40px;
    justify-content: space-evenly;
    img {
      width: 40px;
      height: 40px;
      margin-right: 20px;
    }
    .value-prop {
      display: flex;
      width: 45%;
      margin-bottom: 20px;
    }
  }
}
@media only screen and (max-width: $screen-sm) {
  .content {
    flex-direction: column;
    .value-props {
      margin-top: 20px;
      margin-left: 0;
      justify-content: space-between;
    }
  }
}
@media only screen and (max-width: $screen-xs) {
  .content {
    .value-props {
      flex-direction: column;
      justify-content: space-between;
      .value-prop {
        width: 100%;
      }
    }
  }
}
</style>
